// 代理商加盟api接口
import qs from "qs";
import agentService from "@/services/agentService";
import { objToQuery } from "@/utils/index";

/**
 * 登录获取api key
 * @param {*} data
 */
export function login(data) {
  return agentService.post("/sessions", qs.stringify(data));
}

/**
 * 申请加盟
 * @param {*} data
 */
export function applyAgent(data) {
  return agentService.post("/affiliate/users", data);
}

/**
 * 查看收益
 * @param {*} data
 */
export function getIncome(data) {
  return agentService.get(`/affiliate/users/commission${objToQuery(data)}`);
}

/**
 * 更新银行信息
 * @param {*} data
 */
export function updateBank(data) {
  return agentService.put("/affiliate/user/banks", data);
}
